<template>
  <div class="col-12 voucher-preview">
    <div class="d-flex">
      <div class="media">
        <div class="media-body">
          <div class="h2 preview-header">แบบตัวอย่าง</div>
          <div class="preview-sub-header">เค้าโครงมือถือ</div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="mobile-box text-center">
        <mobile-box
          :title="title"
          :imageUrl="imageUrl"
          :contentHtml="contentHtml"
        ></mobile-box>
      </div>
    </div>
  </div>
</template>

<script>
import MobileBox from "./MobileBox";

export default {
  props: ["value", "imageUrl", "contentHtml"],
  components: {
    MobileBox
  },
  computed: {
    title() {
      return this.value.title;
    }
  }
}
</script>

<style scoped>
.voucher-preview {
  padding-top: 16px;
}
.preview-sub-header {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
}
</style>


// WEBPACK FOOTER //
// src/features/ruejai-club/modules/voucher-package/components/VoucherPreview.vue